/*eslint no-unused-vars: ["error", { "argsIgnorePattern": "_" }]*/
import { createContext } from 'use-context-selector';

export const ChecklistEditorContext = createContext({});
export const ChecklistEditorDispatchContext = createContext((_action) => {
    throw new Error("You must configure the context with a dispatch function.");
});
